import React from 'react';
import Tippy from '../ReactTippy';
import RequireIcon from '../RequireIcon';

/**
 * グループヘッダー表示部分
 * @param {string} fieldName 現場名
 * @param {GroupName} groupName グループ名
 * @param {function} setGroupName グループ名を更新する関数
 **/
function RenderGroupNameDisplay({ fieldName, groupName, setGroupName }) {
  return (
    <RenderBaseNameDisplay>
      <RenderEditName
        labelName={'グループ名'}
        editName={groupName}
        setEditName={setGroupName}
      />
      <RenderShowFieldName fieldName={fieldName} />
    </RenderBaseNameDisplay>
  );
}

/**
 * トークルームヘッダー表示部分(編集可)
 * @param {string} fieldName 現場名
 * @param {TalkroomName} talkroomName トークルーム名
 * @param {function} setTalkroomName トークルーム名を更新する関数
 **/
function RenderEditTalkroomNameDisplay({
  fieldName,
  talkroomName,
  setTalkroomName,
}) {
  return (
    <RenderBaseNameDisplay>
      <RenderEditName
        labelName={'トークルーム名'}
        editName={talkroomName}
        setEditName={setTalkroomName}
      />
      <RenderShowFieldName fieldName={fieldName} />
    </RenderBaseNameDisplay>
  );
}

/**
 * トークルームヘッダー表示部分(閲覧のみ)
 * @param {string} fieldName 現場名
 * @param {TalkroomName} talkroomName トークルーム名
 **/
function RenderShowTalkroomNameDisplay({ fieldName, talkroomName }) {
  return (
    <RenderBaseNameDisplay>
      <RenderShowTalkroomName talkroomName={talkroomName} />
      <RenderShowFieldName fieldName={fieldName} />
    </RenderBaseNameDisplay>
  );
}

function RenderBaseNameDisplay(props) {
  return (
    <div className='dialog__body--header'>
      <div className='dialog__body__item'>{props.children}</div>
    </div>
  );
}

function RenderEditName({ labelName, editName, setEditName }) {
  const _setEditName = e => {
    const name = e.target.value;
    setEditName(prevStatus => {
      return prevStatus.setValue(name);
    });
  };
  return (
    <div className='form-list form-list-default'>
      <div className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            {labelName}
            <RequireIcon />
          </span>
        </div>
        <div
          className={`form-list__element ${(editName.isInvalid() || '') &&
            'form-list__element--error'}`}
        >
          <input
            className='name'
            type='text'
            onBlur={_setEditName}
            defaultValue={editName.value}
          />
          {editName.isInvalid() ? (
            <div className='validate-message show'>
              {editName.getErrorMessage()}
            </div>
          ) : (
            <div className='validate-message show' />
          )}
        </div>
      </div>
    </div>
  );
}

function RenderShowTalkroomName({ talkroomName }) {
  return (
    <div className='form-list form-list-default'>
      <div className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>トークルーム名</span>
        </div>
        <div className='form-list__element'>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={<div className='lw-tooltip-content'>{talkroomName}</div>}
          >
            <span className='label-value'>{talkroomName}</span>
          </Tippy>
        </div>
      </div>
    </div>
  );
}

function RenderShowFieldName({ fieldName }) {
  return (
    <div className='field-name'>
      <span className='field-name__label'>現場名</span>{' '}
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={<div className='lw-tooltip-content'>{fieldName}</div>}
      >
        <div className='field-name__content'>{fieldName}</div>
      </Tippy>
    </div>
  );
}

export {
  RenderGroupNameDisplay,
  RenderEditTalkroomNameDisplay,
  RenderShowTalkroomNameDisplay,
};



// WEBPACK FOOTER //
// ./src/components/lwUser/nameDisplay.jsx